export const urlQuestionList = '/api/XOrg/BookMaterial/getquestionlist';
export const urlQuestionSave = '/api/XOrg/BookMaterial/savequestion';
export const urlQuestionDel = '/api/XOrg/BookMaterial/deletequestion';
export const urlQuestionInfo = '/api/XOrg/BookMaterial/getquestioninfo';
export const urlUploadUrl = '/api/XOrg/BookMaterial/uploadExcel';
export const urlEditPaperQuestionFiles = '/api/XOrg/BookMaterial/editPaperQuestionFiles';

import http from 'lib/http';

export interface IQuestionList {
  code: string;
  myid: string;
  otherid: string;
  list: {
    questionId: string;
    dateCreated: string;
    createrName: string;
    createUserId: string;
    knowledgeId: string;
    questionType: string;
    difficulty: string;
    content: string;
    contentText: string;
    selectContent: Array<string>;
    answerContent: Array<string>;
    questionOrder: string;
    analysis: string;
    checked: boolean;
  }[];
  pagination: {
    pageIndex: string;
    pageSize: string;
    totalCount: string;
  };
}

export interface IQuestionInfo {
  code: string;
  question: {
    Id: string;
    DateCreated: string;
    CreateUserId: string;
    CreateUserName: string;
    CreateDisplayName: string;
    CourseId: string;
    CourseName: string;
    KnowledgeId: string;
    QuestionType: number;
    Difficulty: number;
    Content: string;
    ContentText: string;
    Selects: Array<string>;
    SelectContent: string;
    Answers: Array<string>;
    AnswersContent: string;
    QuestionOrder: string;
    Analysis: string;
    IsDelete: boolean;
  };
  stemFiles: {
    type: string;
    Id: string;
    DocTitle: string;
    DocExtension: string;
    DocUrl: string;
    DocPrviewUrl: string;
  }[];
  analysisFile: {
    type: string;
    Id: string;
    DocTitle: string;
    DocExtension: string;
    DocUrl: string;
    DocPrviewUrl: string;
  }[];
}

// 获取题目列表
export function GetQuestionList(
  courseId?: string,
  knowledgeId?: string,
  keyvalue?: string,
  queTypevalue?: string,
  diffTypeValue?: string,
  page?: number,
  notset?: string,
  pageSize?: number,
  IsTest?: boolean,
  IsNoPageing?: boolean) {
  return http.get<IQuestionList>(urlQuestionList, {
    params: {
      courseId,
      knowledgeId,
      keyvalue,
      queTypevalue,
      diffTypeValue,
      page,
      notset,
      pageSize,
      IsTest,
      IsNoPageing
    }
  });
}

// 保存题目
export function SaveQuestion(
  courseId: string,
  knowledgeId: string,
  questionType: string,
  difficulty: string,
  content: string,
  correctSelectJson: string,
  analysis: string,
  selectJson: string,
  fileIds?: Array<string>,
  analysisFileIds?: Array<string>,
  questionId?: string,
  answersIsDisorder?: boolean
  ) {
  return http.post(urlQuestionSave, {
    courseId,
    knowledgeId,
    type: questionType,
    difficult: difficulty,
    content,
    correctSelectJson,
    selectJson,
    fileIds,
    analysisFileIds,
    analysis,
    questionId,
    answersIsDisorder
  });
}
// 删除题目
export function DelQuestion(questionId: string) {
  return http.post(urlQuestionDel, {
    questionId
  });
}
// 编辑题目时获取题目信息
export function EditQuestion(questionId: string) {
  return http.get<IQuestionInfo>(urlQuestionInfo, {
    params: { questionId }
  });
}

export interface IErrorList {
  code: number;
  msg: string;
  list: {
    row: string;
    error: string;
  }[];
}
export function UploadExcel(courseId: string, file: any) {
  return http.post<IErrorList>(urlUploadUrl, {
    courseId,
    file
  });
}

/**
 * 保存综合题url
 */
export const urlSaveCombineQue = '/api/XOrg/BookMaterial/saveCombineQuestion';

/**
 * 通用返回值
 */
export interface RequestResult {
  code: number;
  msg: string;
}

/**
 * 保存综合题function
 */
export function saveCombineQue(
  content: string,
  knowledgeId: string,
  difficult: number,
  dataJson: string,
  courseId: string,
  files: any,
  questionId: string) {
  return http.post<RequestResult>(urlSaveCombineQue, {
    content,
    knowledgeId,
    difficult,
    dataJson,
    courseId,
    files,
    questionId
  });
}



  /**
   * 获取综合题详情url
   */
export const urlGetCombineQuestionInfo = "/XOrg/BookMaterial/getCombineQuestionInfo";

/**
 * 通用返回值
 */
export interface ResultCombineQuestion {
  code: number;
  msg: string;
  question: {
    Id: string;
    DateCreated: string;
    CreateUserId: string;
    CreateUserName: string;
    CreateDisplayName: string;
    CourseId: string;
    CourseName: string;
    KnowledgeId: string;
    QuestionType: number;
    Difficulty: number;
    Content: string;
    ContentText: string;
    Selects: Array<string>;
    SelectContent: string;
    Answers: Array<string>;
    AnswersContent: string;
    QuestionOrder: string;
    Analysis: string;
    IsDelete: boolean;
  };
  subQuestionList:{
    questionTitle:string;
    radioData:Array<string>;
    correctAnswer:string;
    analysisContent:string;
    sortOrder:number;
  }[];
}

/**
 * 获取综合题详情function
 */
export function GetCombineQuestionInfo(questionId:string) {
  return http.post<ResultCombineQuestion>(urlGetCombineQuestionInfo, {
    questionId
  });
}


// 修改题目附件
export interface IEditPaperQuestionFiles{
  coode: number;
  msg: string;
}

export function EditPaperQuestionFiles(questionId: string , type: number , fileId: any) {
  return http.post<IEditPaperQuestionFiles>(urlEditPaperQuestionFiles, {
    questionId , type , fileId
  });
}